"use client";
import { Button } from "@cmp-src/primitives/button";
import React from "react";
import { useIsMultiRoomSelectionEnabled } from "@/features/reserve/hooks/useIsMultiRoomSelectionEnabled";
import { useRoomSelection } from "@/features/reserve/providers/roomSelectionContext";

const classes = {
  Hud: "flex items-center gap-3 rounded-full bg-neutral-900 py-2 pr-2 pl-5 shadow-lg",
  Label: "font-medium text-sm text-white",
  CancelButton: "h-8 rounded-full bg-white px-4 text-neutral-900"
};

/**
 * Bottom-center prompt shown while the map is armed to add another room to the
 * reservation being composed.
 */
export const MapRoomPickingHud: React.FC = () => {
  const isMultiRoomSelectionEnabled = useIsMultiRoomSelectionEnabled();
  const { isPickingRoom, cancelPicking } = useRoomSelection();

  if (!isMultiRoomSelectionEnabled || !isPickingRoom) {
    return null;
  }

  return (
    <div className={classes.Hud}>
      <span className={classes.Label}>Pick a room on the map to add</span>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        className={classes.CancelButton}
        onClick={cancelPicking}
      >
        Cancel
      </Button>
    </div>
  );
};
